<template>
    <div class="table-info">
        <div class="header">
            <div
                class="item"
                v-for="(column, index) in columns"
                :key="index + ''"
                :style="{ width: column.width || '25%' }"
                :class="[column.type === 'priority' && 'priority']"
            >
                {{ column.title }}
            </div>
        </div>
        <div
            v-if="tableData.length"
            class="list"
            :class="{ _list: tableType === '出价记录' }"
            @click="viewDetails($event)"
        >
            <vue-seamless
                :data="tableData"
                ref="seamlessScroll"
                :class-option="seamlessOptions"
            >
                <div
                    class="item"
                    :class="tableType === '竞拍' ? '_item' : ''"
                    v-for="(d, index) of tableData"
                    :key="index + ''"
                    :data-code="d.id"
                >
                    <div
                        :class="[
                            'text',
                            c.type ? `-${c.type}` : '',
                            c.type === 'priority' && 'priority',
                            d[c.tag] === 1 && 'tag'
                        ]"
                        v-for="(c, i) of columns"
                        :key="i + '' + index"
                        :style="{ width: c.width || '25%' }"
                        :data-code="d.id"
                    >
                        <template v-if="c.type === 'countdown'">
                            <div>倒计时</div>
                            <div>{{ d[c.field] }}</div>
                        </template>
                        <template v-else-if="c.type === 'deal'">
                            <div>{{ d[c.field][0] }}</div>
                            <div class="count">{{ d[c.field][1] }}</div>
                        </template>
                        <template v-else-if="c.type === 'priority'">
                            <div class="number">{{ d[c.field] }}</div>
                        </template>
                        <template v-else>
                            <span
                                v-if="c.type === 'statusColor'"
                                :class="[
                                    d[c.statusField] === 3 ? '-start' : '',
                                    d[c.statusField] === 4 ? '-complete' : ''
                                ]"
                                :data-code="d.id"
                                >{{ d[c.field] }}</span
                            >
                            <span v-else :data-code="d.id">{{
                                d[c.field]
                            }}</span>
                        </template>
                    </div>
                </div>
            </vue-seamless>
        </div>
        <div v-else class="empty">暂无数据</div>
    </div>
</template>

<script>
import vueSeamless from 'vue-seamless-scroll'

export default {
    components: {
        vueSeamless
    },
    props: {
        /**
         * 列配置
         * [
         *  {
         *    title: {string} 列名称
         *    field: {string} 值的字段
         *    type: {string} 显示类型 normal | emphasize | countdown
         *    width: {string} 宽度，百分比
         *  }
         * ]
         */
        columns: {
            type: Array,
            default: () => []
        },
        // 列表类型
        tableType: {
            type: String,
            default: ''
        },
        // 滚动个数限制
        limitMoveNum: {
            type: Number,
            default: 5
        },
        /**
         * 数据
         * [
         *  {
         *    [key]: {any}
         *  }
         * ]
         */
        tableData: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            seamlessOptions: {
                step: 0.5,
                limitMoveNum: this.limitMoveNum,
                openTouch: false,
                waitTime: 1,
                direction: 1,
                singleHeight: 40
            }
        }
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper.$swiper
        }
    },
    // filters: {
    //     sliceLength(value, i) {
    //         if (i === 0 && value) {
    //             if (value.length <= 18) return value
    //             return value.slice(0, 18)
    //         } else {
    //             return value
    //         }
    //     }
    // },
    watch: {
        tableData: {
            handler: function() {
                this.$forceUpdate()
            }
        }
    },
    methods: {
        viewDetails(e) {
            if (this.tableType === '竞拍' && e.target.dataset.code) {
                this.$router.push({
                    path: '/' + this.$route.params.id + '/details',
                    query: {
                        id: e.target.dataset.code,
                        custom:
                            this.$route.name === 'haiken' ? 'haiken' : 'screen',
                        isHeader: this.$route.query.isHeader
                    }
                })
                location.reload()
            }
        }
    },
    mounted() {}
}
</script>

<style lang="scss" scoped>
.table-info {
    width: 100%;
    height: 100%;
    padding: 0 8px 0;
    box-sizing: border-box;
    > .header {
        height: 36px;
        line-height: 36px;
        background: rgba(51, 167, 240, 0.31);
        display: flex;
        justify-content: space-around;
        font-weight: 500;

        > .item {
            font-size: 16px;
            color: #ffffff;
            text-align: center;
            flex-shrink: 1;
            font-family: PingFangSC-Medium;

            &.priority {
                padding-left: 30px;
                box-sizing: border-box;
            }
        }
    }

    > .list {
        margin-top: 9px;
        height: 216px;
        overflow: hidden;
        &._list {
            height: 426px;
        }
        .item {
            margin-bottom: 9px;
            padding: 2px 0 4px 0;
            height: 36px;
            background: rgba(86, 113, 255, 0.23);
            display: flex;
            justify-content: space-around;
            align-items: center;
            &._item {
                cursor: pointer;
            }
            .text {
                line-height: 20px;
                font-size: 12px;
                color: #67f0ff;
                text-align: center;
                flex-shrink: 1;
                word-wrap: break-word;
                word-break: normal;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                line-clamp: 2;
                -webkit-box-orient: vertical;
                &.-emphasize {
                    color: #ff9c00;
                    line-height: 18px;
                }

                .-start {
                    color: #21e060;
                    line-height: 18px;
                }

                .-complete {
                    color: #ff1515;
                    line-height: 18px;
                }

                &.-deal {
                    > .count {
                        color: #ff9c00;
                    }
                }

                &.-countdown {
                    padding-right: 13px;
                    text-align: right;
                }

                &.priority {
                    padding-left: 30px;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    box-sizing: border-box;
                    position: relative;

                    .number {
                        word-wrap: break-word;
                        word-break: normal;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        line-clamp: 2;
                        -webkit-box-orient: vertical;
                    }
                    &.tag::after {
                        position: absolute;
                        left: 0;
                        top: 50%;
                        transform: translateY(-50%);
                        display: block;
                        content: '优';
                        width: 25px;
                        height: 25px;
                        text-align: center;
                        line-height: 25px;
                        color: #fff;
                        background-color: #ff9c00;
                        border-radius: 50%;
                    }
                }
            }
        }
    }
    > .empty {
        padding: 20px 0;
        color: #fff;
        font-size: 18px;
        text-align: center;
    }
}
</style>
